var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as crypto from 'crypto';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class Pjlink {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.hashCode = '';
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${this.hashCode}%1AVMT ?`, /%1AVMT=(\d+)|ERR|WAIT/i, tags);
                // Check for either audio-and-video Mute or just video-Mute.
                if (match[1])
                    return match[1] === '31' || match[1] === '11';
                return this.state.displayBlank.value;
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(
                // Set to audio-and-video mute.
                `${this.hashCode}%1AVMT ${blank ? '31' : '30'}`, /%1AVMT=(OK)|ERR/i, tags);
                if (match[1])
                    return blank;
                return this.state.displayBlank.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${this.hashCode}%1POWR ?`, /%1POWR=(\d)|OK|ERR|WAIT|UNSELECTED/i, tags);
                if (match[1])
                    return match[1] === '1' || match[1] === '3';
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 15000 : 10000);
                this.framework.suspendPolling(power ? 15000 : 10000);
                const match = yield this.socket.send(`${this.hashCode}%1POWR ${power ? '1' : '0'}`, /%1POWR=(OK|ERR|WAIT|UNSELECTED)/i, tags);
                if (match[1] === 'OK')
                    return power;
                return this.state.power.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${this.hashCode}%1INPT ?`, /%1INPT=(\d+)|ERR|WAIT/i, tags);
                if (match[1])
                    return match[1];
                return this.state.videoInput.value;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                this.state.videoInput.update(code); // provide immediate feedback since we will delay
                const match = yield this.socket.send(`${this.hashCode}%1INPT ${code}`, /%1INPT=(OK)|ERR/i, tags, { sendTimeoutMs: 3000 } // Some projectors take longer to respond to source changes
                );
                yield this.timeouts.delay(2000); // allow time for input to set before room power off
                this.state.busy.update(false);
                if (match[1])
                    return code;
                return this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['power', 'videoInput'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.state.busy.update(false);
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    next: (command) => {
                        const regex = /PJLINK \d\s*([0-9a-f]*)/i;
                        const match = command.match(regex);
                        if (!match)
                            return false;
                        if (match && match[1]) {
                            const onConnectCode = match[1];
                            const hashInput = `${onConnectCode}JBMIAProjectorLink`;
                            this.hashCode = crypto
                                .createHash('md5')
                                .update(hashInput)
                                .digest('hex');
                        }
                        return true;
                    },
                },
                {
                    errorCode: 'verifyFailed',
                    send: () => `${this.hashCode}%1POWR ?`,
                    next: /%1POWR=\d+|%1POWR=ERR/i,
                },
            ], credentials);
        });
    }
}
// static properties
Pjlink.driverType = 'socketDriver';
Pjlink.key = '-NEa5nYSs--N8sGD30nS';
Pjlink.socketOptions = [
    {
        commandExtractor: {
            terminators: ['\r'],
        },
        sendTerminator: '\r',
        port: 4352,
    },
];
